import { Error } from 'grpc-web';

export const httpStatusFromGRPCError = (err: Error): string => {
  switch (err.code) {
    case 13:
      return '500';
    case 5:
      return '404';
    default:
      return 'API';
  }
};
